import styled from 'styled-components'
import { breakpoints } from '../../../../constants'
import { BLUE, DARKGRAY } from '../../../../styles/colors.style'
import ImgCard from '../../../../../../client/assets/static/muvicard.png'

export const ContainerStatus = styled.section`
	background: ${BLUE};
	padding: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 184px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		width: 310px;
	}

	.lk-resume {
		&.bill {
			margin-top: 7px;
		}
	}

	.partial-payment-info {
		display: block;
		font-size: 15px;
		margin-top: 5px;
	}
`

export const ImageCard = styled.figure`
	background: url(${ImgCard}) no-repeat;
	background-size: cover
	width: 100%;
	display: flex;
	align-items: flex-end;
	height: 195px;
	padding: 30px 20px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		height: 181px;	
	}

	p {
		color:${DARKGRAY};
		font: 600 18px 'Source Sans Pro';
	}
`

export const FooterCard = styled.footer`
	border-top: 1px solid rgba(255, 255, 255, 0.25);
	width: 263px;
	margin-top: 5px;
	padding-top: 5px;

	.lk-resume {
		width: 245px;
	}
`
